import HostShareCtrl from './HostShareCtrl';

export default HostShareCtrl;
export * from './HostShareCtrl.type';
